export default __webpack_public_path__ + "static/media/labelbg02.54c8ee1d.png";